import script from "./XInputText.vue?vue&type=script&lang=ts&setup=true"
export * from "./XInputText.vue?vue&type=script&lang=ts&setup=true"

import "./XInputText.vue?vue&type=style&index=0&id=d953742c&lang=css&scoped=true"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d953742c"]])

export default __exports__